const handleHeadlessLink = function(url: string) {
  const linkArray = url.split('/');
  const start = url.startsWith('http') ? 3 : 1;

  return  '/' + (linkArray.slice(start, linkArray.length).join('/'));
}

export default handleHeadlessLink;